import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import type { DepositFilters } from '@/features/accounting-bank/deposit-api'
import { DepositList } from '@/features/accounting-bank/deposit-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the bank-deposits list.
 *
 * The list's search and status filter live in the URL search params so a
 * filtered view is linkable and survives a reload; `DepositList` matches them
 * client-side, because the endpoint takes no query parameters.
 */
export const Route = createFileRoute('/_authenticated/accounting/deposits/')({
  validateSearch: (search: Record<string, unknown>): DepositFilters => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
    status:
      search.status === 'draft' || search.status === 'posted' || search.status === 'void'
        ? search.status
        : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bank.view'))
      throw redirect({ to: '/accounting' })
  },
  component: DepositsRoute,
})

function DepositsRoute() {
  const navigate = useNavigate()
  const params = Route.useSearch()

  return (
    <DepositList
      params={params}
      onParamsChange={(next) => void navigate({ to: '/accounting/deposits', search: next })}
    />
  )
}
